export const track = (event) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event });
    document.dispatchEvent(new CustomEvent("bp-analytics", { detail: { event } }));
  } catch {}
};
